import React from "react"
import styled from "styled-components"
import {mobileBannerUrl, desktopBannerUrl} from "../containers/dummyData"

const ImageBanner = () => {
  return (
    <Container>
      <TopBanner mobileBannerUrl={mobileBannerUrl} desktopBannerUrl={desktopBannerUrl} />
    </Container>
  )
}

export default ImageBanner

interface TopBannerProps {
  mobileBannerUrl: string
  desktopBannerUrl: string
}

const TopBanner = styled.div<TopBannerProps>`
  height: 100%;
  width: 100%;
  background-position: center center;
  background-size: cover;
  background-image: ${({mobileBannerUrl: mobileUrl}) => `url(${mobileUrl})`};

  ${({theme, desktopBannerUrl: desktopUrl}) => theme.mediaQueries.minWidthMedia.desktop`
    background-image: url(${desktopUrl});
  `}
`

const Container = styled.div`
  height: 152px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    height: 210px;
  `}
`
